module.exports = __webpack_public_path__ + "static/media/green4.66fc6fe4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/green4.svg
// module id = 1335
// module chunks = 31